import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import Story from "./Pages/Story";
import ChildDevelopment from "./Components/Services/ChildDevelopment/ChildDevelopment";
import OccupationalSkills from "./Components/OccupationalSkills/OccupationalSkills";
import TechnologyInnovation from "./Components/TechnologyInnovation/TechnologyInnovation";
import Consultancy from "./Components/Services/Consultancy/Consultancy";
import Contact from "./Pages/Contact";
import { Navigate } from "react-router-dom";
import EnquiryForm from "./Pages/EnquiryForm";
import { useEffect } from "react";
import moment from "moment";
import Notiflix from "notiflix";
import PostApiCall from "./helpers/PostApi";
import Demo from "./Pages/demo";
import WorkBasedPlacement from "./Components/Services/WorkBasedPlacement/WorkBasedPlacement";
import CorporateTraining from "./Components/Services/CorporateTraining/CorporateTraining";
import ArtificialIntelligent from "./Components/TechnologyInnovation/ArtificialIntelligence";
import ArtificialIntelligence from "./Components/TechnologyInnovation/ArtificialIntelligence";
import ARBasedTraining from "./Components/TechnologyInnovation/ARBasedTraining";

import Autism from "./Components/KnowledgeCenter/Autism";
import DownSyndrome from "./Components/KnowledgeCenter/DownSyndrome";
import Adhd from "./Components/KnowledgeCenter/Adhd";
import Services from "./Components/Services/Services";
import KnowledgeCenter from "./Components/KnowledgeCenter/KnowledgeCenter";
import DevelopmentalDelays from "./Components/KnowledgeCenter/DevelopmentalDelays";


function App() {

  useEffect(() => {
    GetToken() // token generation
  }, [])

  function GetToken() {
    PostApiCall.postRequest(
      {
        email: "admin@globaltrendz.com",
        password: "",
        action: 'Login',
        actiondate: moment().format('lll'),
      }, "addwebistelogin").then((results) =>

        results.json().then(obj => {
          if ((results.status == 200 || results.status == 201)) {

            localStorage.setItem('access', JSON.stringify(obj.token))
            // localStorage.setItem('LoginData', JSON.stringify(obj.data))
            // console.log(obj)
            // window.location.href = `/dashboard`;

          }
          else {
            Notiflix.Notify.failure(obj.data)
          }
        })
      )

  }


  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path='/admissions' element={<Navigate to="/child-skill-development" />} />
          <Route path='/voluntering.aspx' element={<Navigate to="/consultancy" />} />
          <Route path='/news' element={<Navigate to="/our-story" />} />
          <Route path='/events' element={<Navigate to="/our-story" />} />
          <Route path='/photo' element={<Navigate to="/our-story" />} />
          <Route path='/video' element={<Navigate to="/our-story" />} />
          {/* <Route path='/autism' element={<Navigate to="/child-skill-development" />} /> */}
          <Route path='/careers' element={<Navigate to="/contact-us" />} />
          <Route path='/leads' element={<Navigate to="/contact-us" />} />
          <Route path='/mythsandfactsofautism' element={<Navigate to="/" />} />


          <Route exact path="/our-story" element={<Story />} />
          <Route exact path="/child-skill-development" element={<ChildDevelopment />} />
          <Route exact path="/occupational-skills" element={<OccupationalSkills />} />
          <Route exact path="/technology-innovation" element={<TechnologyInnovation />} />
          <Route exact path="/consultancy" element={<Consultancy />} />
          <Route exact path="/contact-us" element={<Contact />} />
          <Route exact path="/demo" element={<Demo />} />
          <Route exact path="/enquiryform" element={<EnquiryForm />} />

          {/* Services */}
          <Route exact path="/services" element={<Services />} />

          <Route exact path="/work-based-placement" element={<WorkBasedPlacement />} />
          <Route exact path="/corporate-training" element={<CorporateTraining />} />



          {/* Technology & Innovation */}
          <Route exact path="/artificial-intelligence" element={<ArtificialIntelligence />} />
          <Route exact path="/ar-based-training" element={<ARBasedTraining />} />


          {/* Knowledge Center */}
          <Route exact path="/adhd" element={<Adhd />} />
          <Route exact path="/autism" element={<Autism />} />
          <Route exact path="/developmental-delays" element={<DevelopmentalDelays />} />
          <Route exact path="/down-syndrome" element={<DownSyndrome />} />
          <Route exact path="/knowledge-center" element={<KnowledgeCenter />} />








        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
